<!-- OTA Zorunlu Güncelleme Modalı -->
<!-- Backdrop tıklanabilir değil — kullanıcı kapatamaz -->
<div class="ota-overlay">
  <div
    class="ota-modal"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="ota-title"
    aria-live="assertive"
  >
    <!-- İkon -->
    <div class="ota-icon-wrapper">
      <div class="ota-icon-ring">
        <img
          src="assets/img/brand/SAGEL_SMALL.svg"
          alt="Sagel Logo"
          class="ota-logo"
        />
      </div>
    </div>

    <!-- Başlık -->
    <h2 id="ota-title" class="ota-title">Güncelleme Gerekli</h2>

    <!-- Açıklama -->
    @if (!updateInfo.isStoreUpdate) {
    <p class="ota-desc">
      Sagel'in yeni bir sürümü mevcut
      <strong>(v{{ updateInfo.version }})</strong>. Uygulamayı kullanmaya devam
      edebilmek için güncellemeniz gerekmektedir.
    </p>
    } @if (updateInfo.isStoreUpdate) {
    <p class="ota-desc">
      Sagel'in yepyeni bir sürümü mağazada mevcut
      <strong>(v{{ updateInfo.version }})</strong>. Güvenliğiniz ve yeni
      özellikler için lütfen uygulamayı mağazadan güncelleyiniz.
    </p>
    }

    <!-- İndirme Durumu -->
    @switch (state) {
    <!-- Bekleme -->
    @case ('idle') {
    <button id="ota-update-btn" class="ota-btn" (click)="startUpdate()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="7 10 12 15 17 10"></polyline>
        <line x1="12" y1="15" x2="12" y2="3"></line>
      </svg>
      {{
        updateInfo.isStoreUpdate ? "Mağazadan Güncelle" : "Güncellemeyi Başlat"
      }}
    </button>
    <p class="ota-mandatory-note">⚠ Güncelleme zorunludur. İptal edilemez.</p>
    }
    <!-- İndiriliyor -->
    @case ('downloading') {
    <div class="ota-download-anim-wrapper">
      <div class="ota-large-spinner"></div>
      <span class="ota-download-text">Güncelleme İndiriliyor...</span>
      <span class="ota-download-subtext">Lütfen uygulamayı kapatmayın</span>
    </div>
    <button
      id="ota-update-btn-downloading"
      class="ota-btn ota-btn--loading"
      disabled
    >
      Lütfen bekleyin...
    </button>
    }
    <!-- Hata -->
    @case ('error') {
    <div class="ota-error-box">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      {{ errorMessage }}
    </div>
    <!-- Teknik hata detayı -->
    @if (errorDetail) {
    <div class="ota-error-detail">
      <span class="ota-error-detail__label">Hata detayı:</span>
      <code class="ota-error-detail__code">{{ errorDetail }}</code>
      <button
        class="ota-copy-btn"
        (click)="copyError()"
        [class.ota-copy-btn--copied]="copied"
        type="button"
      >
        @if (!copied) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
          <path
            d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
          ></path>
        </svg>
        } @if (copied) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        }
        {{ copied ? "Kopyalandı!" : "Kopyala" }}
      </button>
    </div>
    }
    <button id="ota-retry-btn" class="ota-btn" (click)="retry()">
      Tekrar Dene
    </button>
    } }
  </div>
</div>
